import { Languages } from './../_enumerations/languages';

/**
 * Keep current selected Company. Note: This is only work for Admin Portal.
 */
export class SJIAppContext {
    
    constructor() {
        this.isAdminPortal = false;
        this.companyId = '';
        this.companyName = '';
        this.companyTheme = '';
        this.domain = '';
        this.language = 'en-us';
    }
    /**
     *  By default value = false. if field "IsAdminPortal" = true in table dbo.ClientDomain,
     *  set this value = true, which means current accessing portal is admin.
     *  Note: If isAdminPortal = true, there will be no companyId. Since Admin portal is not company portal.
     * */
    isAdminPortal: boolean;

    /** Associated company's CompanyId.
     * In Admin sitem, when selected company from the top menu drop down,
     * the selected company Id will keep here.
     * */
    companyId: string;

    /** Associated company's CompanyName.
     *  In Admin sitem, when selected company from the top menu drop down,
     *  the selected company's name will keep here. Same as CompanyId.
     * */
    companyName: string;

    /** When got current access company, get company's theme from Company.ThemeId -> ThemeCode */
    companyTheme: string;
    /**
     * Current access company portal's domain. Same as field "Domain" in table ClientDomain.
     */
    domain: string;
    /**
     * Current applied language. Note: Different with logon user's default language.
     * Default value same as logon user's langauge. But user is able to reset this language in the Home page language drop down.
     */
    language: string;
}
